import React, { useState } from "react";

const ALLOWED_MODULES = [1, 2, 3, 7, 15, 16];

function currentMonth() {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;
}

export default function ViewAttendance() {
  const localUser = (() => {
    try { return JSON.parse(localStorage.getItem("user") || "null"); } catch { return null; }
  })();

  const moduleId   = parseInt(localUser?.moduleId, 10);
  const employeeId = parseInt(localUser?.id,        10);

  const [month,   setMonth]   = useState(currentMonth);
  const [report,  setReport]  = useState(null);
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState("");

  const handleView = async () => {
    setLoading(true);
    setError("");
    setReport(null);
    try {
      const res = await fetch(
        `/api/attendance/personal-monthly?employeeId=${employeeId}&moduleId=${moduleId}&date=${month}`
      );
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Failed to load report");
      setReport(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (!ALLOWED_MODULES.includes(moduleId)) {
    return (
      <div className="container mt-4">
        <div className="alert alert-danger">Unauthorized access.</div>
      </div>
    );
  }

  return (
    <div className="container mt-4">
      <h4 className="mb-3">Monthly Attendance Register</h4>

      {/* Controls */}
      <form
        className="row g-2 align-items-end mb-3"
        onSubmit={e => { e.preventDefault(); handleView(); }}
      >
        <div className="col-auto">
          <label className="form-label mb-0 small">Select Month</label>
          <input
            type="month"
            className="form-control form-control-sm"
            value={month}
            onChange={e => setMonth(e.target.value)}
            required
          />
        </div>
        <div className="col-auto">
          <label className="form-label mb-0 small d-block" style={{ visibility: "hidden" }}>View</label>
          <button
            type="submit"
            className="btn btn-primary btn-sm"
            disabled={loading}
          >
            {loading ? "Loading…" : "View"}
          </button>
        </div>
      </form>

      {error && <div className="alert alert-danger py-2">{error}</div>}

      {report && (
        <>
          <h5 className="mb-2">
            {report.empName} &mdash; {report.month} {report.year}
          </h5>

          <div className="table-responsive">
            <table className="table table-bordered table-striped table-sm align-middle">
              <thead style={{ background: "#008080", color: "#fff" }}>
                <tr>
                  <th>Date</th>
                  <th>Time In</th>
                  <th>Time Out</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {report.days.map(day => (
                  <tr
                    key={day.date}
                    style={
                      day.dayName === "SUN" || day.dayName === "SAT"
                        ? { background: "#f0f8ff" }
                        : {}
                    }
                  >
                    <td style={{ whiteSpace: "nowrap" }}>{day.label}</td>
                    <td>{day.timeIn}</td>
                    <td>{day.timeOut}</td>
                    <td>
                      {day.timeStatus && (
                        <span style={{ color: day.timeColor }}>{day.timeStatus}</span>
                      )}
                      {day.timeStatus && day.leaveStatus ? " " : ""}
                      {day.leaveStatus && (
                        <span style={{ color: day.leaveColor }}>{day.leaveStatus}</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Legend */}
          <div className="d-flex flex-wrap gap-3 mt-2 small">
            <span><span style={{ color: "green" }}>■</span> Present / Leave</span>
            <span><span style={{ color: "brown" }}>■</span> Late Entry / Early Exit</span>
            <span><span style={{ color: "red"   }}>■</span> Absent</span>
            <span><span style={{ color: "blue"  }}>■</span> Sunday / Saturday / Holiday</span>
          </div>
        </>
      )}
    </div>
  );
}
